import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card card-drawer background-fb" }
const _hoisted_2 = { class: "card-header header-drawer d-flex flex-row align-items-center justify-content-between" }
const _hoisted_3 = {
  class: "card-body condition-route-body",
  id: "routes"
}
const _hoisted_4 = {
  key: 0,
  class: "condition-route-panel"
}
const _hoisted_5 = { class: "condition-route-panel__header d-flex flex-row align-items-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "condition-route-panel"
}
const _hoisted_8 = { class: "condition-route-panel__header d-flex flex-row align-items-center" }
const _hoisted_9 = { class: "condition-route-panel__default-name" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex justify-content-end align-items-center margin-top-10 condition-route-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "btn-label" }
const _hoisted_15 = { class: "btn-text" }

import {
  computed,
  defineAsyncComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { cloneDeep, uniqueId } from "lodash-es";
import { ElButton } from "element-plus";
import i18n from "@/core/i18n/i18n";
import { showConfirm } from "@/core/popup/dialog";
import { v4 as uuidv4 } from "uuid";
import { assignStepNumber } from "@/flow/utils/stepNumberUtils";
import {
  getRouteInsertionPoint,
  ROUTE_VERTICAL_GAP,
  shiftRouteSiblingBranchesDown,
} from "@/flow/utils/incrementalAddShift";
import RouteNameInput from "@/flow/components/RouteNameInput.vue";
import { flushFlowInputs } from "@/flow/application/conditionInputFlushRegistry";
import { isNodeDetachedFromFlow } from "@/flow/utils/nodeUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditRoute',
  props: {
    step: {},
    stepIndex: {},
    flow: {},
    isNewUi: { type: Boolean },
    outputList: {},
    userDefinedVariables: {},
    systemVariables: {},
    expressions: {},
    metaoutputList: {}
  },
  emits: [
  "close",
  "on-change",
  "remove-step",
  "change-function-visible",
  "closeDrawer",
  "changes-happened",
  "addStepEdge",
  "route-name-change",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const Condition = defineAsyncComponent(
  () => import("@/flow/components/Condition.vue")
);

const emit = __emit;

const props = __props;

const routerStep = ref();
const canAddRoutes = computed(() => !isNodeDetachedFromFlow(routerStep.value));

const visible = ref(false);

const isFirstRun = ref(true);
const syncingFromProps = ref(false);
const conditionRouteListRef = ref<HTMLElement | null>(null);
const isRouteListScrollable = ref(false);
let conditionRouteResizeObserver: ResizeObserver | undefined;

function updateRouteListScrollState() {
  const routeList = conditionRouteListRef.value;
  isRouteListScrollable.value = routeList
    ? routeList.scrollHeight > routeList.clientHeight + 1
    : false;
}

function scheduleRouteListScrollStateUpdate() {
  nextTick(updateRouteListScrollState);
}

function syncRouterStepFromProps(step?: any) {
  syncingFromProps.value = true;
  routerStep.value = step ? cloneDeep(step) : step;
  isRouterIncludeDefault.value = !!step?.routes?.some((item) =>
    item.name.includes("Default")
  );
}

function previewRouteName(route: any, name: string) {
  if (props.isNewUi) {
    emit("route-name-change", { routeId: route.id, name });
  } else {
    route.name = name;
  }
}

function commitRouteName(route: any, name: string) {
  if (route.name !== name) {
    route.name = name;
  }
}

function closeRoutes() {
  visible.value = false;
  emit("close");
}

function getLegacyRoutePosition() {
  return {
    x: routerStep.value.ix * 200 + Math.random(),
    y:
      (routerStep.value.iy + routerStep.value.routes.length + 1) * 200 +
      Math.random(),
  };
}

function addNewRoute(afterIndex?: number) {
  if (!canAddRoutes.value) {
    return;
  }

  const resolvedAfterIndex = Number.isInteger(afterIndex)
    ? Number(afterIndex)
    : routerStep.value.routes.length - 1;
  const routeId = uuidv4();
  const stepOrigId = uuidv4();
  const insertionPoint = props.isNewUi
    ? getRouteInsertionPoint(
        routerStep.value,
        resolvedAfterIndex,
        ROUTE_VERTICAL_GAP
      )
    : null;

  const newStep = {
    id: `new-step-${uuidv4()}`,
    parentId: routeId, // Use routeId (not routerId)
    origId: stepOrigId,
    skipMissingIncomingChain: true,
    position: insertionPoint
      ? {
          x: insertionPoint.x + Math.random(),
          y: insertionPoint.y + Math.random(),
        }
      : getLegacyRoutePosition(),
  };
  if (props.flow) {
    assignStepNumber(newStep, props.flow);
  }

  const insertedRouteIndex = resolvedAfterIndex + 1;
  routerStep.value.routes.splice(insertedRouteIndex, 0, {
    id: routeId,
    parentId: routerStep.value.id,
    origId: uuidv4(),
    steps: [newStep],
    name: `Condition ${insertedRouteIndex + 1}`,
    filter: null,
  });
  if (props.isNewUi) {
    shiftRouteSiblingBranchesDown(
      routerStep.value,
      insertedRouteIndex,
      ROUTE_VERTICAL_GAP
    );
  }

  addStepEdge(stepOrigId);
}

const activeCondition = ref<number>(-1);

function setActiveCondition(index: number) {
  activeCondition.value = index;
}
const isRouterIncludeDefault = ref(false);

function addDefaultRoute() {
  if (!canAddRoutes.value) {
    return;
  }

  let contains = false;
  isRouterIncludeDefault.value = true;
  routerStep.value.routes.forEach((item) => {
    if (item.name === t("Condition.DefaultCondition")) {
      contains = true;
    }
  });
  if (!contains) {
    const routeOrigId = uuidv4();
    const routeId = uuidv4();
    const stepOrigId = uuidv4();
    const insertionPoint = props.isNewUi
      ? getRouteInsertionPoint(
          routerStep.value,
          routerStep.value.routes.length - 1,
          ROUTE_VERTICAL_GAP
        )
      : null;
    const newStep: any = {
      id: uniqueId("router-step"),
      origId: stepOrigId,
      parentId: routeId,
      skipMissingIncomingChain: true,
    };
    if (insertionPoint) {
      newStep.position = {
        x: insertionPoint.x + Math.random(),
        y: insertionPoint.y + Math.random(),
      };
    }
    if (props.flow) {
      assignStepNumber(newStep, props.flow);
    }
    routerStep.value.routes.push({
      id: routeId,
      origId: routeOrigId,
      parentId: routerStep.value.id,
      steps: [newStep],
      name: t("Condition.DefaultCondition"),
      filter: [
        {
          leftParen: false,
          rightParen: false,
          firstInput: "[]",
          secondInput: "[]",
          condition: "DEFAULT",
          rule: null,
        },
      ],
    });
    addStepEdge(stepOrigId);
  }
}

async function removeRoute(index) {
  const route = routerStep.value?.routes?.[index];

  if (!route) {
    return;
  }

  const isLastCondition = routerStep.value.routes.length === 1;
  const isConfirmed = await showConfirm(
    "warning",
    t("Common.DeleteCondition"),
    isLastCondition
      ? t("Common.DeleteLastConditionRouteMessage")
      : t("Common.DeleteConditionRouteMessage")
  );

  if (!isConfirmed) {
    return;
  }

  if (route.name.includes("Default")) {
    isRouterIncludeDefault.value = false;
  }

  if (isLastCondition) {
    emit("remove-step", props.stepIndex, props.step);
    emit("close");
  } else {
    routerStep.value.routes.splice(index, 1);
  }
}

function changeFunctionVisible(functionVisible) {
  emit("change-function-visible", functionVisible);
}

function filterChange(filter, index) {
  routerStep.value.routes[index].filter = filter;
}
function checkIndex(route) {
  return route.findIndex((item) => item.name.includes("Default"));
}

function addStepEdge(origId: string) {
  const sourceOrigId = routerStep.value?.origId;

  if (!sourceOrigId) {
    return;
  }

  emit("addStepEdge", {
    source: sourceOrigId,
    target: origId,
  });
}

watch(
  () => routerStep.value,
  () => {
    if (routerStep.value) {
      if (syncingFromProps.value) {
        syncingFromProps.value = false;
        return;
      }
      const tempRoutes = routerStep.value.routes;
      const defultRoutes = [];
      tempRoutes.forEach((element, index) => {
        if (
          element.name.includes("Default") &&
          checkIndex(tempRoutes) !== tempRoutes.length - 1
        ) {
          defultRoutes.push(element);
          tempRoutes.splice(index, 1);
        }
      });
      tempRoutes.push(...defultRoutes);
      routerStep.value.routes = tempRoutes;
      emit("on-change", props.stepIndex, routerStep.value);
      if (isFirstRun.value) {
        isFirstRun.value = false;
      } else {
        emit("changes-happened");
      }
    }
  },
  { deep: true, flush: "sync" }
);

watch(
  () => props.step,
  (step) => {
    syncRouterStepFromProps(step);
  },
  { immediate: true }
);

watch(
  () => routerStep.value?.routes,
  () => {
    scheduleRouteListScrollStateUpdate();
  },
  { deep: true, immediate: true }
);

onMounted(() => {
  scheduleRouteListScrollStateUpdate();
  if (typeof ResizeObserver !== "undefined" && conditionRouteListRef.value) {
    conditionRouteResizeObserver = new ResizeObserver(
      updateRouteListScrollState
    );
    conditionRouteResizeObserver.observe(conditionRouteListRef.value);
  }
  window.addEventListener("resize", updateRouteListScrollState);
});

onBeforeUnmount(() => {
  flushFlowInputs();
  if (conditionRouteResizeObserver) {
    conditionRouteResizeObserver.disconnect();
  }
  window.removeEventListener("resize", updateRouteListScrollState);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(t)("Common.ConditionSettings")) + " ", 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        id: "filter-close",
        onClick: closeRoutes
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "times" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        ref_key: "conditionRouteListRef",
        ref: conditionRouteListRef,
        class: _normalizeClass(["condition-route-list overflow-auto", {
          'condition-route-list--scrollable': isRouteListScrollable.value,
        }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerStep.value?.routes, (route, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex flex-column",
            key: 
            route.origId ||
            route.id ||
            route.steps?.[0]?.origId ||
            route.steps?.[0]?.id
          
          }, [
            (route.name !== 'Default Condition')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(RouteNameInput, {
                      class: "condition-route-panel__name",
                      placeholder: _unref(t)('Common.Name'),
                      id: 'route-name-input-' + index,
                      "model-value": route.name,
                      onPreview: ($event: any) => (previewRouteName(route, $event)),
                      onCommit: ($event: any) => (commitRouteName(route, $event))
                    }, null, 8, ["placeholder", "id", "model-value", "onPreview", "onCommit"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link-icon condition-route-panel__remove",
                      onClick: ($event: any) => (removeRoute(index))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "trash",
                        size: "sm",
                        class: "fa-fw"
                      })
                    ], 8, _hoisted_6)
                  ]),
                  _createVNode(_unref(Condition), {
                    "step-index": _ctx.stepIndex,
                    "in-router": true,
                    class: "margin-top-10",
                    "id-suffix": index.toString(),
                    "output-list": _ctx.outputList,
                    "user-defined-variables": _ctx.userDefinedVariables,
                    "system-variables": _ctx.systemVariables,
                    expressions: _ctx.expressions,
                    "is-active": activeCondition.value === index,
                    onFocused: ($event: any) => (setActiveCondition(index)),
                    "metaoutput-list": _ctx.metaoutputList,
                    conditions: route.filter,
                    onAddDefault: addDefaultRoute,
                    onOnChange: ($event: any) => (filterChange($event, index)),
                    onChangeFunctionsVisible: changeFunctionVisible
                  }, null, 8, ["step-index", "id-suffix", "output-list", "user-defined-variables", "system-variables", "expressions", "is-active", "onFocused", "metaoutput-list", "conditions", "onOnChange"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(route.name), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link-icon condition-route-panel__remove",
                      onClick: ($event: any) => (removeRoute(index))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "trash",
                        size: "sm",
                        class: "fa-fw"
                      })
                    ], 8, _hoisted_10)
                  ])
                ]))
          ]))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          disabled: isRouterIncludeDefault.value || !canAddRoutes.value,
          class: "btn btn-link",
          onClick: addDefaultRoute
        }, _toDisplayString(_unref(t)("Common.AddDefaultCondition")), 9, _hoisted_12),
        _createVNode(_unref(ElButton), {
          class: "no-border btn-oneTeg-table-create btn-labeled condition-route-add",
          "native-type": "button",
          size: "mini",
          type: "primary",
          disabled: !canAddRoutes.value,
          onClick: addNewRoute
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("Common.AddCondition")), 1)
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(ElButton), {
          class: "btn-oneTeg3 condition-route-close",
          "native-type": "button",
          size: "mini",
          onClick: closeRoutes
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})